
import { GET_API } from '../../Functionalities/APIs'

export const ManageInnerCategory = async (e, data, keyword, params) => {
  // e.preventDefault()
    const path = "/items/innercategory/";
    // void 0

    if (keyword == "get") {
        // void 0

        let result = GET_API("", params, path);
        // void 0

        return await result.then((result) => {
            // void 0
            if (result) {
                return result;
            } else {
                return 0;
            }
        });
    }
};
